<template>
    <div
        class="l-ss-c-filter-container"
        :data-filter-id="filter.id">
        <template v-if="shouldRenderContainer">
            <template v-if="!positionLeft && !collapseMode">
                <dropdown
                    v-if="filter.type !== 'checkbox'"
                    :label="label"
                    placement="left">
                    <template #dropdown>
                        <component
                            :is="resolveFilterComponent(filter.type)"
                            :show-title="false"
                            :type="filter.name"
                            force-show-all
                            v-bind="filterCommonProps"
                            @change="onChangeFilter"
                            @filter-click="params => $emit('filter-click', params)"/>
                    </template>
                </dropdown>

                <component
                    v-else
                    :is="resolveFilterComponent(filter.type)"
                    :show-title="false"
                    :type="filter.name"
                    force-show-all
                    v-bind="filterCommonProps"
                    @change="onChangeFilter"
                    @filter-click="params => $emit('filter-click', params)"/>
            </template>

            <template v-else>
                <h4
                    v-if="!withInnerTitle"
                    class="l-ss-c-filter-title">
                    <span>{{ label }}</span>
                </h4>
                <component
                    v-show="!isCollapsed"
                    :is="resolveFilterComponent(filter.type)"
                    :show-title="false"
                    :type="filter.name"
                    :force-show-all="false"
                    v-bind="filterCommonProps"
                    @change="onChangeFilter"
                    @change-size="$emit('change-size')"
                    @filter-click="params => $emit('filter-click', params)"/>
            </template>
        </template>
        <template v-else>
            <component
                :is="resolveFilterComponent(filter.type)"
                :show-title="filter.type === 'checkbox'"
                v-bind="filterCommonProps"
                @change="onChangeFilter"
                @filter-click="params => $emit('filter-click', params)"
                @ready="() => toggleOpen(false)"/>
        </template>
    </div>
</template>

<script>
    import * as filters from './../common/filters/filter-types';
    import cutText from '../../helpers/cut-text';

    import iconArrowTop from '@/core/assets/images/icons/arrow-top.svg';
    // Import Collapse from '@/core/components/collapse.vue';
    import Dropdown from '@/core/components/common/dropdown.vue';

    import firstLetterToUpperCase from '@/core/helpers/first-letter-to-upper-case';

    const LABEL_MAX_LENGTH = 30;

    export default {
        components: {
            Dropdown,
        // Collapse
        },
        filters: {
            cut(value) {
                return cutText(value, LABEL_MAX_LENGTH);
            },
        },
        props: {
            filter: {
                type: Object,
                required: true,
            },
            value: {
                type: [Object, String],
                required: false,
            },
            allCategoriesList: {
                type: Array,
            },
            isShort: {
                type: Boolean,
                default: false,
            },
            symbol: {
                type: String,
                default: '',
            },
            collapseMode: {
                type: Boolean,
                default: false,
            },
            withInnerTitle: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isCollapsed: false,
            };
        },
        computed: {
            positionLeft() {
                return this.$configuration.layout.filterPosition === 'left' && !this.$screen.isMobile;
            },
            shouldRenderContainer() {
                const filterTypes = ['m-toggle'];

                if (this.positionLeft) {
                    filterTypes.push('checkbox');
                }

                return filterTypes.includes(this.filter.type) === false;
            },
            iconArrowTop() {
                return iconArrowTop;
            },
            label() {
                const label = this.$t(`filters.byType.${this.filter.name}`);
                const resultLabel = label ? (label.label || label.title) || this.filter.name : this.filter.name;

                return firstLetterToUpperCase(resultLabel);
            },
            filterCommonProps() {
                return {
                    ...this.$props,
                    isShort: this.isShort,
                    symbol: this.symbol,
                };
            },
            showLabelCounter() {
                return Boolean(typeof this.value === 'object' && this.value.options instanceof Array && this.value.options.length > 0);
            },
        },
        methods: {
            resolveFilterComponent(type) {
                return filters.resolveFilterComponent(type);
            },
            onChangeFilter(data) {
                const filterRect = this.$el.getBoundingClientRect();
                this.$emit('change', {
                    data,
                    filterData: {
                        filterRect,
                        filterId: this.filter.id,
                    },
                });
            },
        },
    };
</script>
